<template>
  <div id="knowledgeDetail">
    <div class="overlay" v-if="showLoading">
      <div div style="position:fixed;
          top: 50%;
          left: 50%;
          z-index:999999">
        <vue-loaders-ball-spin-fade-loader color="#173B6B" scale="1.5">
        </vue-loaders-ball-spin-fade-loader>
      </div>
    </div>
    <span class="titleProduct">{{knowledgeTitleName}}</span>
    <KnowledgeDetail></KnowledgeDetail>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import KnowledgeDetail from '../components/Knowledge/KnowledgeDetail.vue';

export default {
  components: {
    KnowledgeDetail,
  },
  async created() {
    const { id } = this.$route.params;
    await this.$store.dispatch('Knowledge/clearState');
    await this.$store.dispatch('Knowledge/getKnowledgeDetail', id);
  },
  computed: {
    ...mapGetters('Knowledge', ['knowledgeDetail', 'showLoading']),
    KnowledgeName() {
      return this.knowledgeDetail.name;
    },
  },
  watch: {
    KnowledgeName() {
      if (this.knowledgeDetail.name !== null && this.knowledgeDetail.name !== ''
        && this.knowledgeDetail.name !== undefined) {
        const trimTitle = this.knowledgeDetail.name.trim();
        if (trimTitle.length !== 0) {
          this.knowledgeTitleName = this.knowledgeDetail.name;
        } else {
          this.knowledgeTitleName = 'ชื่อมองรู้ดูออก';
        }
      } else {
        this.knowledgeTitleName = 'ชื่อมองรู้ดูออก';
      }
    },
  },
  data() {
    return {
      knowledgeTitleName: 'ชื่อมองรู้ดูออก',
    };
  },
};
</script>

<style>
  .titleProduct {
    font-size: 30px;
    color: #173B6B;
  }
  .adminLatestUpdate {
    margin-left: 30px;
    color: #28a745;
  }
  .smeLatestUpdate {
    margin-left: 30px;
    color: red;
  }
  #knowledgeDetail {
    padding-left: 20px;
  }
  .overlay {
    background-color:#EFEFEF;
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1;
    top: 0px;
    left: 0px;
    opacity: 0.3;
  }
</style>
